import { render, staticRenderFns } from "./SafetyReport.vue?vue&type=template&id=348528ba&scoped=true&"
import script from "./SafetyReport.vue?vue&type=script&lang=js&"
export * from "./SafetyReport.vue?vue&type=script&lang=js&"
import style0 from "./SafetyReport.vue?vue&type=style&index=0&id=348528ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348528ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348528ba')) {
      api.createRecord('348528ba', component.options)
    } else {
      api.reload('348528ba', component.options)
    }
    module.hot.accept("./SafetyReport.vue?vue&type=template&id=348528ba&scoped=true&", function () {
      api.rerender('348528ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/SafetyReport.vue"
export default component.exports